module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"submit":"Soumettre","cancel":"Annuler","title":"Edition de la propriété","processing":"Traitement en cours...","technical":"Technique","synoptic":"Synoptique","schemas":"Schémas","download":"Télécharger","uploadFiles":"Pièces jointes"}}')
  delete Component.options._Ctor
}
